import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getData } from '../../../../../actions/apiCall';
import CustomTabs, { tabsProps } from '../../../../../components/Tabs';
import { constants } from '../../../../../constants/common';
import CandidateInfo from './report/personal_details';
import DoccumentVerify from './report/doccuments_verify';
import ExperianceVerify from './report/experiance_verify';
import Reports from './report/Reports';

const DoccumentReport = ({ id }) => {
    const [userData, setResData] = useState();
    const [activeTab, setActiveTab] = useState(null);
    const [formData, setFormData] = useState({});
    const [tabs, setTabs] = useState<tabsProps[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (id) {
            getFormTabs(id);
        }
    }, [id])

    const getFormTabs = async (id) => {
        try {
            if (id) {
                const resData = await dispatch(getData('/form-data-admin/forms/' + id));
                if (resData.code == 200) {
                    const _tabs = resData.data.sort((a, b) => a.order - b.order).map(ele => ({
                        label: ele?.name,
                        key: ele._id,
                        content: <></>
                    }))

                    setTabs(_tabs);
                    setActiveTab(_tabs[0].key);
                    setFormData(resData.data);
                }
            }

        } catch (error) {
            console.log("errrr", error)
        }
    }

    const onTabChange = (e) => {
        setActiveTab(e)
    }

    const onRefresh = () => {
        dispatch({
            type: 'REFRESH_TABLE',
            refreshTable: true
        })
    }

    return <React.Fragment>
        <CustomTabs
            tabs={tabs}
            defaultActiveKey={activeTab}
            onTabChange={onTabChange}
        />
        <>
            {activeTab && <Reports candidateId={id} tabId={activeTab} />}
        </>
    </React.Fragment>
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.app.isAuthenticated,
    user: state.app.user,
});

export default connect(mapStateToProps)(DoccumentReport);
